import React from 'react';

import FantasyLineupTrophyUrl from '@pkg/assets/images/w3-auth/fantasy-lineup-trophy.png';
import FantasyLineupUrl from '@pkg/assets/images/w3-auth/fantasy-lineup.png';

import { Container, Lineup, Trophy } from './styles';

export function FantasyLineupIllustration() {
    return (
        <Container>
            <Lineup src={FantasyLineupUrl} />
            <Trophy src={FantasyLineupTrophyUrl} />
        </Container>
    );
}
